<template>
  <details class="mt-3 text-sm text-gray-700">
    <summary class="cursor-pointer underline">
      Browser observations
    </summary>
    <p class="my-2">
      These are browser reports, not proof of cheating. Monitoring coverage is unknown, including across reloads and unsupported devices. No report does not mean an event could not have happened. An IP change does not establish a change of location.
    </p>
    <p v-if="!attempts.length">
      No observations available.
    </p>
    <div
      v-for="(item, index) in attempts"
      :key="item.id || index"
      class="my-3"
    >
      <p class="font-medium">
        {{ item.examName || item.examSlug || `Assessment ${index + 1}` }}
      </p>
      <dl>
        <div
          v-for="row in rows(item)"
          :key="row[0]"
          class="flex flex-wrap gap-2 py-1"
        >
          <dt class="font-medium mr-2">
            {{ row[0] }}:
          </dt><dd>{{ row[1] }}</dd>
        </div>
      </dl>
    </div>
  </details>
</template>
<script>
import { observationRows } from '@utils/assessmentObservations'
export default {
  props: { candidate: { type: Object, default: null }, attempt: { type: Object, default: null } },
  computed: { attempts() { return this.attempt ? [this.attempt] : ((this.candidate && this.candidate.attempts) || []) } },
  methods: { rows: observationRows }
}
</script>
